export default "__VITE_ASSET__9033c512__"